"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainConfig = void 0;
const contracts_js_1 = require("./contracts.js");
const formatters_js_1 = require("./formatters.js");
const serializers_js_1 = require("./serializers.js");
exports.chainConfig = {
    contracts: contracts_js_1.contracts,
    formatters: formatters_js_1.formatters,
    serializers: serializers_js_1.serializers,
};
//# sourceMappingURL=chainConfig.js.map